'use client';

import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle, cn } from '@repo/ui';
import { Home } from 'lucide-react';
import Link from 'next/link';
import type React from 'react';
import { LazyLottie } from '../../components/lazy-lottie';

export function ComingSoonTemplate({
  className,
  homeHref = '/',
  title = 'Coming Soon',
  description = 'This page is under construction. We are working hard to bring you something amazing.',
  ...props
}: React.ComponentProps<'div'> & {
  homeHref?: string;
  title?: string;
  description?: string;
}): React.ReactNode {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-6 select-none pt-[15vh]',
        className,
      )}
      {...props}
    >
      <div className="flex items-center justify-center">
        <LazyLottie
          src="/lottie/coming-soon.lottie.json"
          className="h-72 rounded-lg overflow-hidden"
        />
      </div>
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">{title}</CardTitle>
          <CardDescription className="text-base">{description}</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4">
          <Button asChild>
            <Link href={homeHref}>
              <Home />
              Go Home
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
